import { create } from './BaseService';

const http = create();

// Order

export function createOrder(order, preorderId) {
  return http.post('/new-order', { order, preorderId });
}

export function getOrders() {
  return http.get('/my-orders');
}

export function findOrder(id) {
  return http.get(`/orders/${id}`);
}

export function updateOrder(payment) {
  return http.post('/update-order/', { payment });
}

// Preorder

export function createPreorder(cartItems) {
  return http.post('/new-preorder/', { cartItems });
}

export function getPreorders() {
  return http.get('/my-preorders/');
}

export function findPreorder(preorderId) {
  return http.get(`/preorder/${preorderId}`);
}

export function updatePreorder(data, preorderId) {
  return http.post('/update-preorder/', { data, preorderId });
}

export function doPayment(payment) {
  return http.post('/payment', { payment });
}

export function removePreorder(preorderId) {
  return http.post('/remove-preorder', { preorderId });
}
